const AppConstants = {
  QA_URL: window.location.origin,
  APP_NAME: 'LockerVision',
  WIDGET_API_KEY: 'ZfVlypp6UydS1Jmjb3Ih9dGjxp4ZnKGn',
  WIDGET_API_ID: 'LOCKERVISION_EN_US',
  WIDGET_ENV: 'prod',
  WIDGET_MODEL: true,
  MODEL: false,
  DISPLAY_SPONSORS: true,
  START_DATE_FILTER: 'StartDateFilter',
  END_DATE_FILTER: 'EndDateFilter',
  TEAM_FILTER: 'TeamFilter',
  GAME_TYPE_FILTER: 'GameTypeFilter',
  ACTIVE_TILE: 'activeTile',
  TILES_POSITION: 'tilesPosition',
  ALL_TEAMS: 'All Teams',
  ALL_GAMES: 'All Games',
  THUMBNAIL_KEY: 'Transformation_Thumbnail',
  CARD_KEY: 'Transformation_Card',
  HAT_KEY: 'Transformation_Hat',
  COURT_KEY: 'Transformation_Court',
  TOWEL_KEY: 'Transformation_Towel',
  BASKETBALL_KEY: 'Transformation_Basketball',
  DEFAULT_KEY: 'Transformation_Default',
  SEASON_YEAR: '2021-22',
  REF_HEADER: '71a3fa62-64c0-4edf-ad80-60e0772a7474',
  AD_DISPLAY_DESKTOP: 'DESKTOP',
  AD_DISPLAY_MOBILE: 'MOBILE',
  TBD_PNG: 'tbd.png',
  PAGES: {
    HOME: 'HOME',
    TEAMS: 'TEAMS',
    EDITIONS: 'EDITIONS',
    ABOUTUS: 'ABOUTUS',
    GAMEOUTFIT: 'GAMEOUTFIT',
    OUTFIT: 'OUTFIT',
    SCHEDULE: 'SCHEDULE',
    RISINGSTAROUTFITPREVIEW: 'RISING_STAR_OUTFIT_PREVIEW',
    ALLSTAROUTFITPREVIEW: 'ALL_STAR_OUTFIT_PREVIEW',
    PAGENOTFOUND: "PAGENOTFOUND",
  },
  SEO_QUOTE: "Every Locker, Every Player, Every Game.",
  SEO_KEYWORDS: {
    HOME: "{LEAGUE_NAME} jerseys,Basketball team jerseys,{SEASON_YEAR} {LEAGUE_NAME} jerseys,{LEAGUE_NAME} Uniforms,New {LEAGUE_NAME} jerseys and uniforms",
    SCHEDULE: "{LEAGUE_NAME} Christmas Day jerseys and uniforms,{LEAGUE_NAME} full season uniform schedule",
    TEAMS: "{LEAGUE_NAME} {TEAM_NAME} uniform colors,{LEAGUE_NAME} {TEAM_NAME} jerseys and shorts,All {LEAGUE_NAME} jerseys by team,Total {LEAGUE_NAME} jerseys per team",
    EDITIONS: "{EDITION_NAME} {LEAGUE_NAME} jerseys and shorts,{LEAGUE_NAME} Hardwood {EDITION_NAME} jerseys and shorts,New {LEAGUE_NAME} {EDITION_NAME} jerseys shorts and uniforms,{LEAGUE_NAME} {EDITION_NAME} Jerseys,Alternate {LEAGUE_NAME} {EDITION_NAME} jerseys,Home and Road {LEAGUE_NAME} {EDITION_NAME} jerseys,{LEAGUE_NAME} Throwback {EDITION_NAME} Jerseys,{LEAGUE_NAME} {EDITION_NAME} jerseys shorts and uniforms",
    OUTFIT: "{TEAM_NAME} Jersey design,{LEAGUE_NAME} {TEAM_NAME} Warm-Up jacket,New {LEAGUE_NAME} {TEAM_NAME} jerseys,{LEAGUE_NAME} {TEAM_NAME} {EDITION_NAME} jersey design details",
    GAMEOUTFIT: "{TEAM_NAME} Jersey design,{LEAGUE_NAME} {TEAM_NAME} Warm-Up jacket,New {LEAGUE_NAME} {TEAM_NAME} jerseys,{LEAGUE_NAME} {TEAM_NAME} {EDITION_NAME} jersey design details",
    ALL_STAR_OUTFIT_PREVIEW: "All Star - {TEAM_NAME} Jersey design,{LEAGUE_NAME} {TEAM_NAME} Warm-Up jacket,New {LEAGUE_NAME} {TEAM_NAME} jerseys,{LEAGUE_NAME} {TEAM_NAME} {EDITION_NAME} jersey design details",
    RISING_STAR_OUTFIT_PREVIEW: "Rising Star - {EDITION_NAME} jersey design details",
    ABOUTUS: "Nike basketball jerseys,Jordan brand basketball jerseys",
  },
  SEO_DESCRIPTIONS: {
    HOME: "{LEAGUE_NAME} LockerVision provides a look into the locker room of every {LEAGUE_NAME} team, for every game and every player. It is the premier destination for {LEAGUE_NAME} uniform schedules, jersey and short design details, and on-court collections.",
    TEAMS: "All {LEAGUE_NAME} uniforms by Team via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    EDITIONS: "All {LEAGUE_NAME} uniforms by Edition via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    SCHEDULE: "{LEAGUE_NAME} Uniform Matchup schedule for all games via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    GAMEOUTFIT: "All {LEAGUE_NAME} uniforms by Edition via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    OUTFIT: "All {LEAGUE_NAME} uniforms by Edition via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    ALL_STAR_OUTFIT_PREVIEW: "All Star - All {LEAGUE_NAME} uniforms by Edition via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    RISING_STAR_OUTFIT_PREVIEW: "Rising Star - All {LEAGUE_NAME} uniforms by Edition via {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
    ABOUTUS: "About US and FAQ on {LEAGUE_NAME} LockerVision, the {LEAGUE_NAME}'s home for uniform schedules, jersey and short design details, and on-court collections.",
  },

}

export default AppConstants;